module.exports = __webpack_public_path__ + "static/img/hospital-desfocus.13514c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hospital-desfocus.jpg
// module id = 687
// module chunks = 6